export default {
  state: {
    ai_write_conversations_list: [],
    vuex_stored_conversations: [],
    jumpHistory: {
      index: 0,
      time: -1,
    },
    deletehistoryId: '',
    deleteAllHistory: -1,
  },
  getters: {},
  actions: {
  },
  mutations: {
    setAiWriteConversationList(state, ai_write_conversations_list) {
      state.ai_write_conversations_list = ai_write_conversations_list
    },
    setVuexConversationsList(state, conversations) {
      state.vuex_stored_conversations = conversations;
      // console.error('历史会话 信息 setHistoryList', conversations);
    },
    setJumpHistory(state, jumpHistory) {
      state.jumpHistory = jumpHistory;
    },
    setDeletehistoryId(state, deletehistoryId) {
      state.deletehistoryId = deletehistoryId;
    },
    setDeleteAllHistory(state, deleteAllHistory) {
      state.deleteAllHistory = deleteAllHistory;
    },
  },
  namespaced: true,
}